import React, { useState, useEffect, useMemo } from "react";
import "../../Assests/Scss/AddUpdateQuestions.scss";
import Loading from "../../../../Student/Reusablecomponents/Loading";
import ScenarioQuestionformat from "../../../../Student/Reusablecomponents/ScenarioQuestionformat";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
import DropdownValues from "../../../../Student/Reusablecomponents/DropDownValues";
import {
  MainSource,
  SubMainSource,
  QVStatus,
  DDContent,
  DDTopic,
  DDSubTopic,
  DDLearningOC,
  DDSubLearningOC,
  NCERTLO,
  QuestionLevel,
  FormQuestions,
  BloomTaxonomy,
  DDContext,
  DDSystem,
  DDStream,
  DDSubSytem,
  DDCompetencies,
  DDSubCompetencies,
  DDProcedural,
  DDEpistemic,
  DDContextOne,
  DDContextTwo,
  DDContextThree,
} from "../../../../ReusableComponents/QBDropdowns";
import { GoTriangleDown } from "react-icons/go";
import { Row, Col } from "react-bootstrap";
import TinyMCEDitor from "../../../../ReusableComponents/tinymceEditor";
import notify from "../../../../ReusableComponents/ToastifyAlerts";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import QS from "../../Assests/images/QuestionSource.svg";
import Q from "../../Assests/images/Question.svg";
import LO from "../../Assests/images/LO.svg";
import AP from "../../Assests/images/AParameters.svg";
import Forms from "../../Assests/images/Forms.svg";

import TranslateEditor from "./TranslatEditor";
import axiosInstance from "../../../../ReusableComponents/Axios";
import QBCList from "../../../../ReusableComponents/QBCheckList";
import { DDIssueType } from "../../../../ReusableComponents/QBAdmin/CommonDropdowns";
import {GetLanguagename} from "../../../../ReusableComponents/QBAdmin/QBAFunctions";
const TranslateQuestion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector((state) => state.SelectLanguageData.SLanguage);
  const GetQuestion = useSelector((state) => state.QuestionDeatils.QuestionDetails);
  const Scenario = useSelector((state) => state.ScenarioDeatils.ScenarioDetails);
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const [Load, SetLoad] = useState(false);

  const MDQ = GetQuestion ? GetQuestion?.questionType : location.state?.Tab === "INQ" ? "D" : "M";

  const [Accordion, SetAccordion] = useState("All");
  const [OpenTranslatEditor, CloseTranslatEditor] = useState(false);
  const [EdiText, SetEdiTest] = useState();

  const [EditorValues, SetEditorValues] = useState({
    Question: GetQuestion?.langQuestion || "",
    Answer: GetQuestion?.langAnswer || "",
    OptionA: GetQuestion?.langOptionA || "",
    OptionB: GetQuestion?.langOptionB || "",
    OptionC: GetQuestion?.langOptionC || "",
    OptionD: GetQuestion?.langOptionD || "",
    Explanation: GetQuestion?.langAnswerExplanation || "",
    Misconception: GetQuestion?.langMisconception || "",
  });
  const [OComments, SetOComments] = useState({
    Source: GetQuestion?.otherQSource || "",
    Verification: GetQuestion?.verificationComment || "",
    Form: GetQuestion?.otherFormComments || "",
  });

  const [NTBased, SetNTBased] = useState(GetQuestion?.sSourceLovId || "");
  const [SNTBased, SetSNTBased] = useState(GetQuestion?.sSourceValueId || "");
  const [VStatus, SetVStatus] = useState(GetQuestion?.qStatus || "");
  const [SelceTOS, SetSelceTOS] = useState(GetQuestion?.typeOfIssue || "");

  const [Content, SetContent] = useState(GetQuestion?.content || "");
  const [Topic, SeTopic] = useState(
    GetQuestion?.topic || FQuestionDetails?.topicId || ""
  );
  const [SubTopic, SetSubTopic] = useState(GetQuestion?.subTopic || FQuestionDetails?.subTopicId || "");

  const [LOC, SetLOC] = useState(GetQuestion?.lo || FQuestionDetails?.loid || "");
  const [SubLOC, SetSubLOC] = useState(GetQuestion?.subLO || FQuestionDetails?.subLOId || "");
  const [NCERTLOC, SetNCERTLOC] = useState(GetQuestion?.ncertlo || "");
  const [GetGrade, SetGetGrade] = useState();
  const [CNumber, SetCNumber] = useState();
  const [ChapterOpt, SetChapterOpt] = useState();
  const [GradeOpt, SetGradeOpt] = useState();
  const [QLevel, SetQLevel] = useState(GetQuestion?.[items?.subjectId === "1" ? "level" : "questionLevel"] || "");
  const [BTaxonomy, SetBTaxonomy] = useState(GetQuestion?.bloomsTaxonomy || "");
  const [Context, SetContext] = useState(GetQuestion?.context || "");

  const [FormQ, SetFormQ] = useState(GetQuestion?.elementType || []);

  const [AQErrors, SetAQErrors] = useState({});

  const [NCERTDetails, SetNCERTDetails] = useState();
  const [OpenNCERTTable, closeNCERTTable] = useState(false);
  // Below are the science variables
  const [SSS, SetSSS] = useState({
    System: GetQuestion?.system || "",
    Stream: GetQuestion?.stream || "",
    SubSytem: GetQuestion?.subSystem || "",
  });

  const [Competencies, SetCompetencies] = useState({
    Competencies: GetQuestion?.competencies || "",
    SubCompetencies: GetQuestion?.subCompetencies || "",
  });
  const [Knowledge, SetKnowledge] = useState({
    Procedural: GetQuestion?.proceduralKnowledge || "",
    Epistemic: GetQuestion?.epistemicKnowledge || "",
  });

  const [ScienceContext, SetScienceContext] = useState({
    ContextOne: GetQuestion?.contextLevel1 || "",
    ContextTwo: GetQuestion?.contextLevel2 || "",
    ContextThree: GetQuestion?.contextLevel3 || "",
  });
  const StoreSSS = (Name, e) => { SetSSS({ ...SSS, [Name]: e }); };

  const StoreCompetencies = (Name, e) => { SetCompetencies({ ...Competencies, [Name]: e }); };

  const StoreKnowledge = (Name, e) => { SetKnowledge({ ...Knowledge, [Name]: e }); };

  const StoreContext = (Name, e) => { SetScienceContext({ ...ScienceContext, [Name]: e }); };

  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    SelceTOS: Yup.string().required("Type of Issue is required"),
    VStatus: Yup.string().required("Verification Status is required"),
    Question: Yup.string().required("Question is required"),
    Answer: Yup.string().required("Answer is required"),
    OptionA: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: (schema) => Yup.string().required("Option A is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    OptionB: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: () => Yup.string().required("Option B is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    QForm: Yup.string().required("Forms in Question is required"),
    Form: Yup.string().when("FormQ", {
      is: (FormQ) => FormQ.includes(4002),
      then: (schema) => Yup.string().required("Form input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Source: Yup.string().when("SNTBased", {
      is: (SNTBased) => SNTBased === 3574 || SNTBased === 3578,
      then: (schema) => Yup.string().required("Source input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
  });

  const OpenAccordain = (e) => {
    if (Accordion === e) {
      SetAccordion();
    } else {
      SetAccordion(e);
    }
  };

  const StoreEditorValues = (Name, Values) => { SetEditorValues({ ...EditorValues, [Name]: Values }); };
  const HandelOComments = (Name, Values) => { SetOComments({ ...OComments, [Name]: Values }); };
  const FormSOptions = (e) => {
    if (FormQ.includes(e)) {
      SetFormQ((prevItems) => prevItems.filter((item) => item !== e));
    } else {
      SetFormQ([...FormQ, e]);
    }
  };
  const QForm = FormQ?.join(",");

  useEffect(() => {
    if (LOC) {
      GETChaptergrade();
    }
  }, [LOC]);
  useMemo(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [AQErrors]);

  const GETChaptergrade = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/GetGradeAndChapterByLO?LovId=${LOC}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const ChapterOp = [];
        const GradeOp = [];
        res.data.map((item) => {
          if (
            !ChapterOp.some((chapter) => chapter.value === item.chapterLovId)
          ) {
            ChapterOp.push({
              display: item.chapterName,
              value: item.chapterLovId,
            });
          }
          if (!GradeOp.some((grade) => grade.value === item.gradeLovId)) {
            GradeOp.push({ display: item.gradeName, value: item.gradeLovId });
          }
        });
        SetChapterOpt(ChapterOp);
        SetGradeOpt(GradeOp);

        SetCNumber(GetQuestion?.chapterId || ChapterOp?.[0].value);
        SetGetGrade(GetQuestion?.gradeId || GradeOp?.[0].value);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NCERTColumns = [
    { name: "LO Code", selector: "lovName", sortable: true },
    {
      name: "Description", selector: "description", sortable: true,
      cell: (row) => (<div style={{ textAlign: "justify" }}>{row.description} </div>),
    },
  ];

  const Validation = () => {
    const AllFields = {
      ...EditorValues,
      NTBased,
      SNTBased,
      VStatus, SelceTOS,
      Content,
      Topic,
      SubTopic,
      LOC,
      SubLOC,
      NCERTLOC,
      GetGrade,
      CNumber,
      QLevel,
      BTaxonomy,
      Context,
      QForm,
      ...OComments,
      FormQ,
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      // .then(() => {
      //   UpdateLanguageQuestion();
      // })
      .then(() => {
        SetAQErrors({});
        if (CValidation) {
          UpdateLanguageQuestion();
        }
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
      });
  };
  const UpdateLanguageQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      TypeOfIssue: SelceTOS,
      questionId: GetQuestion?.questionID,
      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,
      questionVerficationStatus: VStatus,
      ModifiedBy: items?.userId,
      addScenarioQuestionChecklist: QCValues,
      language: GetLanguagename(SelectLanguage)?.[0],
    };

    await axios.post(process.env.REACT_APP_API_BASE_URL +
      `/${items?.subjectId === "1"
        ? "QuestionBank/UpdateMathsHindiLanguageQuestions"
        : "ScienceQuestionBank/UpdateScienceHindiLanguageQuestions"
      }`,
      QuestionInputs,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
      .then((res) => {
        notify("Question updated successfully", "success");
        SetLoad((prev) => !prev);
        navigate(-1);
      })
      .catch((err) => {
        notify("Question not updated. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };
  const BackPreviousPage = () => { navigate(-1); };
  const EditValues = (data, SetData, Holedata, Maindata) => {
    CloseTranslatEditor(!OpenTranslatEditor);
    SetEdiTest({
      value: data,
      Store: SetData,
      opendata: Holedata,
      AData: Maindata,
    });
  };
  const [HitCLV, SetHitCLV] = useState(false);
  const [CValidation, SetCValidation] = useState(false);
  const [QCValues, SetQCValues] = useState();
  useEffect(() => {
    if (CValidation) {
      Validation();
    }
  }, [CValidation]);
  return (
    <>
      <div className="dflex JSBetween alignitems mb-3">
        <div className="MainHeading">Update Question (in {GetLanguagename(SelectLanguage)?.[1]})</div>
        <div></div>
      </div>

      {Scenario?.scenarioID ? (
        <div className="Card mb-3">
          <div className="SubHeading mb-2">
            Scenario (Id - {Scenario?.scenarioID})
          </div>
          <ScenarioQuestionformat scenario={Scenario?.langScenarioName} />
        </div>
      ) : ""}

      <div className="Card">
        {GetQuestion && (
          <div className="SubHeading mb-2">
            Question (Id - {GetQuestion?.questionID})
          </div>
        )}
        <div className="dflex alignitems mb-2" style={{ gap: "30px" }}>
          {["M", "D"].map((item) => (
            <div className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="radio"
                value={item}
                checked={item === MDQ}
                name="Qtype"
                disabled={true}
              /* onChange={(e) => { if (!GetQuestion) { SetEditorValues({ ...EditorValues, Answer: "" }) }; SetMDQ(e.target.value) }}*/
              />{" "}
              {item === "M" ? "MCQ" : "NON MCQ"}
            </div>
          ))}
        </div>
        <div>
          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={QS} alt="Question Source" />{" "}
                <div>
                  Question Source<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("QS")} />
            </div>
            {Accordion !== "QS" && (
              <div className="container-fluid mt-2">
                <Row>
                  <Col>
                    <MainSource
                      className="DisabledNCLDropdown w-100 mb-2"
                      StoreMSource={SetNTBased}
                      SOption={NTBased}
                      LID={SelectLanguage}
                      onChange={(e) => SetNTBased(e)}
                      disable={true}
                      labelname={
                        <div className="DropdownHeader">
                          Source<span>*</span>
                        </div>
                      }
                    />
                    {/* {AQErrors?.NTBased && <span className="error-message">{AQErrors?.NTBased}</span>}</div> */}
                    <SubMainSource
                      className="DisabledNCLDropdown w-100"
                      StoreSMSource={SetSNTBased}
                      SOption={SNTBased}
                      LID={SelectLanguage}
                      PId={NTBased}
                      onChange={(e) => SetSNTBased(e)}
                      disable={true}
                    />
                    {(SNTBased === 3574 || SNTBased === 3578) && (
                      <input
                        type="text"
                        className="Search mt-2 p-1 w-100"
                        onChange={(e) =>
                          HandelOComments("Source", e.target.value)
                        }
                        placeholder="Enter Comments"
                      />
                    )}
                    {AQErrors?.Source && (
                      <span className="error-message">{AQErrors?.Source}</span>
                    )}
                  </Col>
                  <Col>
                    <QVStatus
                      className="NCLDropdown w-100 mb-2"
                      StoreValue={SetVStatus}
                      SOption={VStatus}
                      LID={SelectLanguage}
                      onChange={(e) => SetVStatus(e)}
                    />
                    {AQErrors?.VStatus && (<span className="error-message"> {AQErrors?.VStatus} </span>)}
                    <input
                      type="text"
                      placeholder="Enter text"
                      className="Search p-1 w-100"
                      onChange={(e) =>
                        HandelOComments("Verification", e.target.value)
                      }
                    />
                    <DDIssueType className="NCLDropdown w-100 mb-2" Displayname="Select Type of Issue "
                      StoreValue={SetSelceTOS} SOption={SelceTOS} onChange={(e) => SetSelceTOS(e)} />
                    {AQErrors?.SelceTOS && (<span className="error-message"> {AQErrors?.SelceTOS} </span>)}
                  </Col>
                </Row>
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={Q} alt="Question" />{" "}
                <div>
                  Question<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("Q")} />
            </div>
            {Accordion !== "Q" && (
              <div className="container-fluid mt-2 QuestionOptions">
                <div className="SubHeading mt-2 mb-2 text-capitalize">
                  Question
                </div>
                <Row>
                  <Col className="DisabledTiny">
                    {" "}
                    <TinyMCEDitor
                      PostValue={GetQuestion?.question}
                      disable={true}
                    />{" "}
                  </Col>
                  <Col>
                    {" "}
                    <TinyMCEDitor
                      PostValue={EditorValues?.Question}
                      onChange={(e) => StoreEditorValues("Question", e)}
                      Review={true} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                      onClick={() =>
                        EditValues(
                          EditorValues?.Question,
                          SetEditorValues,
                          EditorValues,
                          "Question"
                        )
                      }
                    />
                    {AQErrors?.Question && (
                      <span className="error-message">
                        {AQErrors?.Question}
                      </span>
                    )}
                  </Col>
                </Row>

                {MDQ !== "D" ? (
                  <>
                    <div
                      className="dflex InputFIlters mt-4 w-50"
                      style={{ gap: "15px", width: "49%" }}
                    >
                      <label style={{ backgroundColor: "white" }}>
                        {" "}
                        Select Answer{" "}
                      </label>
                      {["A", "B", "C", "D"].map((option, i) => (
                        <div
                          key={i}
                          className="dflex alignitems"
                          style={{ gap: "5px", fontSize: "15px" }}
                          onChange={() => StoreEditorValues("Answer", option)}
                        >
                          <input
                            type="radio"
                            value={option}
                            name="Answer"
                            disabled
                            checked={option == EditorValues?.Answer}
                          />{" "}
                          {option}{" "}
                        </div>
                      ))}
                    </div>

                    <div className="SubHeading mt-2 mb-2 text-capitalize">
                      OptionA
                    </div>
                    <Row>
                      <Col className="DisabledTiny">
                        {" "}
                        <TinyMCEDitor
                          PostValue={GetQuestion?.optionA}
                          disable={true}
                        />{" "}
                      </Col>
                      <Col>
                        {" "}
                        <TinyMCEDitor
                          PostValue={EditorValues?.OptionA} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                          onChange={(e) => StoreEditorValues("OptionA", e)}
                          Review={true}
                          onClick={() =>
                            EditValues(
                              EditorValues?.OptionA,
                              SetEditorValues,
                              EditorValues,
                              "OptionA"
                            )
                          }
                        />
                        {AQErrors?.OptionA && (
                          <span className="error-message">
                            {AQErrors?.[`OptionA`]}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <div className="SubHeading mt-2 mb-2 text-capitalize">
                      OptionB
                    </div>
                    <Row>
                      <Col className="DisabledTiny">
                        {" "}
                        <TinyMCEDitor
                          PostValue={GetQuestion?.optionB}
                          disable={true}
                        />{" "}
                      </Col>
                      <Col>
                        {" "}
                        <TinyMCEDitor
                          PostValue={EditorValues?.OptionB} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                          onChange={(e) => StoreEditorValues("OptionB", e)}
                          Review={true}
                          onClick={() =>
                            EditValues(
                              EditorValues?.OptionB,
                              SetEditorValues,
                              EditorValues,
                              "OptionB"
                            )
                          }
                        />
                        {AQErrors?.OptionA && (
                          <span className="error-message">
                            {AQErrors?.[`OptionB`]}
                          </span>
                        )}
                      </Col>
                    </Row>

                    <div className="SubHeading mt-2 mb-2 text-capitalize">
                      OptionC
                    </div>
                    <Row>
                      <Col className="DisabledTiny">
                        {" "}
                        <TinyMCEDitor
                          PostValue={GetQuestion?.optionC}
                          disable={true}
                        />{" "}
                      </Col>
                      <Col>
                        {" "}
                        <TinyMCEDitor
                          PostValue={EditorValues?.OptionC} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                          onChange={(e) => StoreEditorValues("OptionC", e)}
                          Review={true}
                          onClick={() =>
                            EditValues(
                              EditorValues?.OptionC,
                              SetEditorValues,
                              EditorValues,
                              "OptionC"
                            )
                          }
                        />{" "}
                      </Col>
                    </Row>

                    <div className="SubHeading mt-2 mb-2 text-capitalize">
                      OptionD
                    </div>
                    <Row>
                      <Col className="DisabledTiny">
                        {" "}
                        <TinyMCEDitor
                          PostValue={GetQuestion?.optionD}
                          disable={true}
                        />{" "}
                      </Col>
                      <Col>
                        {" "}
                        <TinyMCEDitor
                          PostValue={EditorValues?.OptionD} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                          onChange={(e) => StoreEditorValues("OptionD", e)}
                          Review={true}
                          onClick={() =>
                            EditValues(
                              EditorValues?.OptionD,
                              SetEditorValues,
                              EditorValues,
                              "OptionD"
                            )
                          }
                        />{" "}
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <div className="SubHeading mt-2 mb-2 text-capitalize">
                      Answer
                    </div>
                    <Row>
                      <Col className="DisabledTiny">
                        <TinyMCEDitor
                          PostValue={GetQuestion?.answer}
                          disable={true}
                        />
                      </Col>
                      <Col>
                        <TinyMCEDitor
                          PostValue={EditorValues?.Answer} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                          onChange={(e) => StoreEditorValues("Answer", e)}
                          Review={true}
                          onClick={() =>
                            EditValues(
                              EditorValues?.Answer,
                              SetEditorValues,
                              EditorValues,
                              "Answer"
                            )
                          }
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <div className="SubHeading mt-2 mb-2 text-capitalize">
                  Explanation
                </div>
                <Row>
                  <Col className="DisabledTiny">
                    {" "}
                    <TinyMCEDitor
                      disable={true}
                      PostValue={GetQuestion?.answerExplanation}
                    />{" "}
                  </Col>
                  <Col>
                    {" "}
                    <TinyMCEDitor
                      PostValue={EditorValues?.Explanation} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                      onChange={(e) => StoreEditorValues("Explanation", e)}
                      Review={true}
                      onClick={() =>
                        EditValues(
                          EditorValues?.Explanation,
                          SetEditorValues,
                          EditorValues,
                          "Explanation"
                        )
                      }
                    />{" "}
                  </Col>
                </Row>

                <div className="SubHeading mt-2 mb-2 text-capitalize">
                  Misconception
                </div>
                <Row>
                  <Col className="DisabledTiny">
                    {" "}
                    <TinyMCEDitor
                      PostValue={GetQuestion?.misconception}
                      disable={true}
                    />{" "}
                  </Col>
                  <Col>
                    {" "}
                    <TinyMCEDitor
                      PostValue={EditorValues?.Misconception} LngValue={GetLanguagename(SelectLanguage)?.[0]}
                      onChange={(e) => StoreEditorValues("Misconception", e)}
                      Review={true}
                      onClick={() =>
                        EditValues(
                          EditorValues?.Misconception,
                          SetEditorValues,
                          EditorValues,
                          "Misconception"
                        )
                      }
                    />{" "}
                  </Col>
                </Row>
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={LO} alt="Learning Outcomes" />{" "}
                <div>Learning Outcomes </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("LOC")} />
            </div>
            {Accordion !== "LOC" && (
              <div className="container-fluid mt-2">
                {items?.subjectId === "2" && (
                  <Row>
                    <Col>
                      <DDSystem
                        className="DisabledNCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        StoreValue={SetSSS}
                        SOption={SSS}
                        LID={SelectLanguage}
                        onChange={(e) => StoreSSS("System", e)}
                        disable={true}
                      />
                    </Col>
                    <Col>
                      <DDStream
                        className="DisabledNCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        PId={SSS?.System}
                        StoreValue={SetSSS}
                        SOption={SSS}
                        LID={SelectLanguage}
                        onChange={(e) => StoreSSS("Stream", e)}
                        disable={true}
                      />
                    </Col>
                    <Col>
                      <DDSubSytem
                        className="DisabledNCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        PId={SSS?.Stream}
                        StoreValue={SetSSS}
                        SOption={SSS}
                        LID={SelectLanguage}
                        onChange={(e) => StoreSSS("SubSytem", e)}
                        disable={true}
                      />
                    </Col>
                  </Row>
                )}

                <Row>
                  {items?.subjectId === "1" && (
                    <Col>
                      <DDContent
                        className="DisabledNCLDropdown w-100"
                        SubjectId={items?.subjectId}
                        StoreValue={SetContent}
                        SOption={Content}
                        LID={SelectLanguage}
                        onChange={(e) => SetContent(e)}
                        disable={true}
                      />
                    </Col>
                  )}
                  <Col>
                    <DDTopic
                      className="DisabledNCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={items?.subjectId === "1" ? "" : SSS?.SubSytem}
                      StoreValue={SeTopic}
                      SOption={Topic}
                      LID={SelectLanguage}
                      onChange={(e) => SeTopic(e)}
                      LovCategoryId={items?.subjectId === "1" ? 4 : 25}
                      disable={true}
                      labelName={
                        <div className="DropdownHeader">
                          Topic<span>*</span>
                        </div>
                      }
                    />
                  </Col>
                  <Col>
                    <DDSubTopic
                      className="DisabledNCLDropdown w-100"
                      SubjectId={items?.subjectId}
                      PId={Topic}
                      LID={SelectLanguage}
                      StoreValue={SetSubTopic}
                      SOption={SubTopic}
                      onChange={(e) => SetSubTopic(e)}
                      LovCategoryId={items?.subjectId === "1" ? 5 : 26}
                      disable={true}
                      labelName={
                        <div className="DropdownHeader">
                          Sub Topic<span>*</span>
                        </div>
                      }
                    />{" "}
                  </Col>
                  {items?.subjectId !== "1" && <Col></Col>}
                </Row>

                <Row>
                  <Col>
                    <DDLearningOC className="DisabledNCLDropdown w-100"
                      SubjectId={items?.subjectId} PId={SubTopic} disable={true}
                      StoreValue={SetLOC} SOption={LOC} LID={SelectLanguage}
                      onChange={(e) => SetLOC(e)}  LovCategoryId={items?.subjectId === "1" ? 40 : 27}
                      labelName={ <div className="DropdownHeader"> Learning Outcomes<span>*</span> </div> } />
                  </Col>
                  <Col>
                    <DDSubLearningOC className="DisabledNCLDropdown w-100"
                      SubjectId={items?.subjectId} PId={LOC} LID={SelectLanguage}
                      StoreValue={SetSubLOC} SOption={SubLOC} onChange={(e) => SetSubLOC(e)}
                      LovCategoryId={items?.subjectId === "1" ? 41 : 66} disable={true} />
                  </Col>
                  <Col>
                    <NCERTLO className="DisabledNCLDropdown w-100" SubjectId={items?.subjectId}
                      StoreValue={SetNCERTLOC} SOption={NCERTLOC} LID={SelectLanguage}
                      onChange={(e) => SetNCERTLOC(e)} LovCategoryId={items?.subjectId === "1" ? 8 : 29}
                      GetOptions={SetNCERTDetails} disable={true} />
                    <div className="dflex alignitems CPointer" style={{ fontSize: "10px", gap: "3px" }}
                      onClick={() => {
                        closeNCERTTable(!OpenNCERTTable);
                        document.body.classList.add("modal-open");
                      }} >
                      <IoInformationCircleOutline /> Click to view NCERT LOs
                      description
                    </div>
                  </Col>
                </Row>
                {LOC && (
                  <Row>
                    <Col>
                      <DropdownValues className="DisabledNCLDropdown w-100"
                        options={ChapterOpt} selectoption={CNumber}
                        onChange={(e) => SetCNumber(e.target.value)} disabled={true}
                        labelname={ <div className="DropdownHeader"> CBSE / SCERT Chapter No<span>*</span> </div> } />
                    </Col>
                    <Col>
                      <DropdownValues className="DisabledNCLDropdown w-100"
                        options={GradeOpt} onChange={(e) => SetGetGrade(e.target.value)}
                        selectoption={GetGrade} disabled={true}
                        labelname={<div className="DropdownHeader"> Grade<span>*</span> </div>} />
                    </Col>
                    <Col></Col>
                  </Row>
                )}
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                <img src={AP} alt="Assessment Parameters" />{" "}
                <div>Assessment Parameters </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("AP")} />
            </div>
            {Accordion !== "AP" && (
              <div className="container-fluid mt-2">
                <Row>
                  <Col>
                    <QuestionLevel className="DisabledNCLDropdown w-100"
                      SubjectId={items?.subjectId} StoreValue={SetQLevel}
                      SOption={QLevel} LID={SelectLanguage} disable={true}
                      onChange={(e) => SetQLevel(e)} LovCategoryId={items?.subjectId === "1" ? 1 : 16}
                      labelname={<div className="DropdownHeader"> Question Level <span>*</span> </div>} />
                  </Col>
                  <Col>
                    <BloomTaxonomy className="DisabledNCLDropdown w-100"
                      SubjectId={items?.subjectId} PId={QLevel} LID={SelectLanguage}
                      StoreValue={SetBTaxonomy} SOption={BTaxonomy} onChange={(e) => SetBTaxonomy(e)}
                      LovCategoryId={items?.subjectId === "1" ? 42 : 39} disable={true}
                      labelname={<div className="DropdownHeader"> Bloom's Taxonomy <span>*</span> </div>} />
                  </Col>
                  {items?.subjectId === "1" ? (
                    <Col>
                      <DDContext className="DisabledNCLDropdown w-100"
                        SubjectId={items?.subjectId} StoreValue={SetContext}
                        SOption={Context} LID={SelectLanguage}
                        onChange={(e) => SetContext(e)} disable={true} />
                    </Col>
                  ) : (
                    <Col>
                      <DDCompetencies className="DisabledNCLDropdown w-100" SubjectId={items?.subjectId}
                        StoreValue={SetCompetencies} SOption={Competencies}
                        LID={SelectLanguage} onChange={(e) => StoreCompetencies("Competencies", e)} disable={true} />
                    </Col>
                  )}
                </Row>
                {items?.subjectId === "2" && (
                  <>
                    <Row>
                      <Col>
                        <DDSubCompetencies className="DisabledNCLDropdown w-100"
                          SubjectId={items?.subjectId} PId={Competencies?.Competencies}
                          StoreValue={SetCompetencies} SOption={Competencies}
                          LID={SelectLanguage} onChange={(e) => StoreCompetencies("SubCompetencies", e)} disable={true} />
                      </Col>
                      <Col>
                        <DDProcedural className="DisabledNCLDropdown w-100"
                          SubjectId={items?.subjectId} StoreValue={SetKnowledge}
                          SOption={Knowledge} LID={SelectLanguage}
                          onChange={(e) => StoreKnowledge("Procedural", e)} disable={true} />
                      </Col>
                      <Col>
                        <DDEpistemic className="DisabledNCLDropdown w-100"
                          SubjectId={items?.subjectId} PId={Knowledge?.Procedural}
                          StoreValue={SetKnowledge} LID={SelectLanguage}
                          SOption={Knowledge} onChange={(e) => StoreKnowledge("Epistemic", e)} disable={true} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <DDContextOne className="DisabledNCLDropdown w-100"
                          SubjectId={items?.subjectId} StoreValue={SetScienceContext}
                          SOption={ScienceContext} LID={SelectLanguage}
                          onChange={(e) => StoreContext("ContextOne", e)} disable={true} />
                      </Col>
                      <Col>
                        <DDContextTwo className="DisabledNCLDropdown w-100" SubjectId={items?.subjectId}
                          StoreValue={SetScienceContext} PId={ScienceContext?.ContextOne}
                          SOption={ScienceContext} LID={SelectLanguage}
                          onChange={(e) => StoreContext("ContextTwo", e)} disable={true} />
                      </Col>
                      <Col>
                        <DDContextThree className="DisabledNCLDropdown w-100" SubjectId={items?.subjectId}
                          PIdOne={ScienceContext?.ContextOne} PIdTwo={ScienceContext?.ContextTwo}
                          StoreValue={SetScienceContext} SOption={ScienceContext} LID={SelectLanguage}
                          onChange={(e) => StoreContext("ContextThree", e)} disable={true} />
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                <img src={Forms} alt="Assessment Parameters" />{" "}
                <div> Forms In Question<span className="text-danger">*</span> </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("FQ")} />
            </div>
            {Accordion !== "FQ" && (
              <>
                <FormQuestions PostValues={FormQ} onChange={(e) => FormSOptions(e)} disable={true} LID={SelectLanguage} />
                {FormQ.includes(4002) && (
                  <>
                    <input type="text" className="Search mt-2 p-1 w-100"
                      onChange={(e) => HandelOComments("Form", e.target.value)}
                      placeholder="Enter Comments" />
                    {AQErrors?.Form && (<span className="error-message">{AQErrors?.Form}</span>)}
                  </>
                )}
                {AQErrors?.QForm && (
                  <span className="error-message" style={{ marginLeft: "10px" }} > {AQErrors?.QForm} </span>
                )}
              </>
            )}
          </div>
        </div>


        <hr />

        <QBCList Heading="Question" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
          GetValues={SetQCValues} Existinvalues={GetQuestion?.status} ExistingId={GetQuestion?.checklistQuestionId} LanguageId={SelectLanguage} />

        <div className="ScenarioAU dflex alignitems">
          <button className="Buttons bg-danger" onClick={() => BackPreviousPage()} > Cancel </button>
          <button className="Buttons bg-success"
            onClick={() => { Validation(); SetHitCLV(true); }} >
            {GetQuestion ? (
              <>
                Save / Update{" "}
                <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The
                  Question)
                </span>{" "}
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>

      {OpenNCERTTable && (
        <div className="Model-Open">
          <div className="Card w-100">
            <IoMdCloseCircleOutline className="NCERTClose CPointer"
              onClick={() => {
                closeNCERTTable(!OpenNCERTTable);
                document.body.classList.remove("modal-open");
              }}
            />
            <DataTable data={NCERTDetails} columns={NCERTColumns}
              className="NCLDataTable" Dropdownvalues={["10", "25", "50", "100"]}
              ShowPagination="true" ShowPagecount="true" />
          </div>
        </div>
      )}

      {OpenTranslatEditor && (
        <div className="Model-Open">
          <div className="Card w-100">
            <TranslateEditor close={CloseTranslatEditor} EditData={EdiText} />
          </div>
        </div>
      )}

      {Load && <Loading />}
    </>
  );
};
export default TranslateQuestion;